var routes = {
    HOME: '/',
    LOGIN: '/login',
    LOGOUT: '/logout',
    CBR: '/refund',
    CALLBACK: '/callback',
    ACCOUNTS: '/accounts'
};
export var showInactivityModal = [routes.HOME, routes.CBR];
export default routes;
